// @moods/ui copy for the chat components and the command palette. tr and en must have identical keys.
// Turkish part; chat.en.ts must have the same keys.
const dict: Record<string, string> = {
  // time & dividers
  'chat.time.today': 'Bugün {time}',
  'chat.time.yesterday': 'Dün {time}',
  'chat.day.today': 'Bugün',
  'chat.day.yesterday': 'Dün',
  'chat.unread': 'Yeni',
  'chat.unread.label': 'Yeni mesajlar',
  // message
  'chat.message.label': '{name}, {time}',
  'chat.edited': '(düzenlendi)',
  'chat.editedAt': 'Düzenlendi: {date}',
  'chat.badge.bot': 'BOT',
  'chat.badge.webhook': 'WEBHOOK',
  'chat.deleted': 'Bu mesaj silindi.',
  'chat.state.pending': 'Gönderiliyor',
  'chat.state.failed': 'Mesaj gönderilemedi.',
  'chat.retry': 'Tekrar dene',
  'chat.delete': 'Sil',
  'chat.reply.jump': 'Yanıtlanan mesaja git: {name}, {text}',
  // hover actions
  'chat.actions.label': 'Mesaj eylemleri',
  'chat.actions.quick': 'Tepki: {emoji}',
  'chat.actions.react': 'Tepki ekle',
  'chat.actions.reply': 'Yanıtla',
  'chat.actions.thread': 'Akış oluştur',
  'chat.actions.more': 'Daha fazla',
  // reactions
  'chat.reaction.add': 'Tepki ekle',
  'chat.reaction.group': 'Tepkiler',
  'chat.reaction.label': '{emoji} tepkisi, {count}',
  'chat.reaction.count': '{n} kişi {emoji} ile tepki verdi',
  'chat.reaction.by1': '{a} {emoji} ile tepki verdi',
  'chat.reaction.byOneMore': '{a} ve {n} kişi daha {emoji} ile tepki verdi',
  'chat.reaction.by2': '{a} ve {b} {emoji} ile tepki verdi',
  'chat.reaction.by3': '{a}, {b} ve {c} {emoji} ile tepki verdi',
  'chat.reaction.byMore': '{a}, {b} ve {n} kişi daha {emoji} ile tepki verdi',
  // attachments
  'chat.image.label': 'Görsel',
  'chat.image.open': 'Görseli aç: {name}',
  'chat.spoiler.reveal': 'Spoiler — göster',
  'chat.gallery.label': '{count} görsel',
  'chat.gallery.item': 'Görsel {index}/{count}',
  'chat.gallery.more': '{count} görsel daha',
  'chat.file.download': 'İndir',
  'chat.file.cancel': 'İptal',
  'chat.file.failed': 'Yükleme başarısız',
  'chat.file.uploading': '{name} yükleniyor',
  'chat.embed.play': 'Oynat: {title}',
  'chat.embed.privacy': 'Oynattığında içerik {site} üzerinden yüklenir.',
  'chat.code.label': '{lang} kodu',
  'chat.code.copy': 'Kopyala',
  'chat.code.copied': 'Kopyalandı',
  'chat.code.expand': 'Genişlet ({count} satır daha)',
  'chat.code.collapse': 'Daralt',
  // poll
  'chat.poll.label': 'Anket',
  'chat.poll.votes': '{count} oy',
  'chat.poll.votes.one': '{count} oy',
  'chat.poll.change': 'Oyu değiştir',
  'chat.poll.submit': 'Oy ver',
  'chat.poll.cancel': 'Vazgeç',
  'chat.poll.ended': 'Anket sona erdi',
  'chat.poll.hidden': 'Sonuçlar oy verince görünür',
  // voice message
  'chat.voice.label': 'Sesli mesaj',
  'chat.voice.play': 'Oynat',
  'chat.voice.pause': 'Duraklat',
  'chat.voice.seek': 'Konum',
  'chat.voice.position': '{current} / {total}',
  'chat.voice.speed': 'Oynatma hızı: {rate}',
  // typing
  'chat.typing.one': '{a} yazıyor…',
  'chat.typing.two': '{a} ve {b} yazıyor…',
  'chat.typing.many': 'Birkaç kişi yazıyor…',
  // composer
  'chat.composer.placeholder': '# {channel} kanalına mesaj gönder…',
  'chat.composer.add': 'Ek ekle',
  'chat.composer.gif': 'GIF',
  'chat.composer.emoji': 'Emoji',
  'chat.composer.send': 'Gönder',
  'chat.composer.slowmode': 'Yavaş mod',
  'chat.composer.slowmodeLeft': 'Yavaş mod: {left}',
  'chat.composer.seconds': '{n} sn',
  'chat.composer.attachments': 'Ekler',
  'chat.composer.removeAttachment': 'Kaldır: {name}',
  'chat.composer.replyingTo': 'Yanıtlanıyor:',
  'chat.composer.pingOn': '@ ping açık',
  'chat.composer.pingOff': '@ ping kapalı',
  'chat.composer.cancelReply': 'Yanıtı iptal et',
  'chat.composer.noPermission': 'Bu kanalda mesaj gönderme iznin yok.',
  'chat.composer.timedOut': 'Zaman aşımındasın — {left} kaldı.',
  'chat.composer.blocked': 'Engellediğin birine mesaj gönderemezsin.',
  'chat.format.label': 'Biçimlendirme',
  'chat.format.bold': 'Kalın',
  'chat.format.italic': 'İtalik',
  'chat.format.strike': 'Üstü çizili',
  'chat.format.quote': 'Alıntı',
  'chat.format.code': 'Kod',
  'chat.format.link': 'Bağlantı',
  'chat.format.list': 'Liste',
  // slash commands
  'chat.cmd.label': 'Komutlar',
  'chat.cmd.invite': 'Bu kanal için davet bağlantısı oluştur',
  'chat.cmd.poll': 'Hızlı bir anket başlat',
  'chat.cmd.event': 'Topluluk etkinliği planla',
  'chat.cmd.timeout': 'Bir üyeyi geçici olarak sustur',
  'chat.cmd.timeout.usage': '@üye süre',
  'chat.cmd.gif': 'GIF ara ve gönder',
  'chat.cmd.gif.usage': 'terim',
  'chat.cmd.spoiler': 'Mesajını spoiler olarak gönder',
  'chat.cmd.me': 'Mesajını eylem olarak gönder',
  'chat.cmd.nick': 'Bu topluluktaki takma adını değiştir',
  'chat.cmd.shrug': 'Mesajının sonuna ¯\\_(ツ)_/¯ ekle',
  // jump to present
  'chat.jump.present': 'Şimdiye atla',
  'chat.jump.new': '{count} yeni mesaj',
  'chat.jump.newOne': '{count} yeni mesaj',
  'chat.jump.markRead': 'Okundu olarak işaretle',
  // command palette
  'palette.label': 'Komut paleti',
  'palette.placeholder': 'Nereye gitmek istiyorsun?',
  'palette.prefix.label': 'Arama kapsamı',
  'palette.prefix.channels': 'Kanallar',
  'palette.prefix.people': 'Kişiler',
  'palette.prefix.communities': 'Topluluklar',
  'palette.prefix.commands': 'Komutlar',
  'palette.results': 'Sonuçlar',
  'palette.recent': 'Son kullanılanlar',
  'palette.hint': 'Kanal, kişi, topluluk ya da komut ara.',
  'palette.empty': 'Sonuç bulunamadı',
  'palette.emptyHint': 'Başka bir kelime dene ya da bir kapsam seç.',
  'palette.nav': 'Gezin',
  'palette.select': 'Seç',
  'palette.close': 'Kapat',
};

export default dict;
